import React, { JSX } from 'react';
import styled from 'styled-components';
import MiniCarousel from '../MiniCarousel';

export type MastheadCarouselProps = {
  children: JSX.Element[];
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CarouselWrapper = styled.div``;

const CarouselItem = styled.div`
  text-align: center;
  width: 100%;
`;

const MastheadCarousel: React.FC<MastheadCarouselProps> = ({ children }: MastheadCarouselProps) => {
  const cards = children.map((card, i) => ({ key: i, value: card }));

  return (
    <Container>
      {cards && (
        <CarouselWrapper data-testid="carousel">
          <MiniCarousel autoPlayInterval={4000} showDots={cards.length > 1} showArrows={false}>
            {cards.map((item) => (
              <CarouselItem key={item.key} data-testid="card">
                {item.value}
              </CarouselItem>
            ))}
          </MiniCarousel>
        </CarouselWrapper>
      )}
    </Container>
  );
};

export default MastheadCarousel;
